import { render, staticRenderFns } from "./weight.vue?vue&type=template&id=3ac98c44&scoped=true"
import script from "./weight.vue?vue&type=script&lang=js"
export * from "./weight.vue?vue&type=script&lang=js"
import style0 from "./weight.vue?vue&type=style&index=0&id=3ac98c44&lang=css"
import style1 from "./weight.vue?vue&type=style&index=1&id=3ac98c44&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac98c44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ac98c44')) {
      api.createRecord('3ac98c44', component.options)
    } else {
      api.reload('3ac98c44', component.options)
    }
    module.hot.accept("./weight.vue?vue&type=template&id=3ac98c44&scoped=true", function () {
      api.rerender('3ac98c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/components/weight.vue"
export default component.exports